import axios from "axios";

import { SET_DOCUMENTS } from "./types";
import { createAsyncAction } from "./appActions";
import { getApiUrl } from "../helpers/apiUrlHelpers";
import { saveAs } from "../helpers/fileHelpers";

export const getBillOfLadingDocuments = createAsyncAction(
  resolve => (shipmentId, invoiceId) =>
    resolve(async dispatch => {
      const lang = localStorage.getItem("language");
      const response = await axios.get(`${getApiUrl()}/shipment/${shipmentId}/document`, { params: { invoiceId, lang } });
      dispatch({ type: SET_DOCUMENTS, payload: response.data });
    }),
  dispatch => dispatch({ type: SET_DOCUMENTS, payload: [] })
);

export const getOrderDocuments = createAsyncAction(
  resolve => poId =>
    resolve(async dispatch => {
      const lang = localStorage.getItem("language");
      const response = await axios.get(`${getApiUrl()}/purchaseorder/${poId}/document`, { params: { lang } });
      dispatch({ type: SET_DOCUMENTS, payload: response.data });
    }),
  dispatch => dispatch({ type: SET_DOCUMENTS, payload: [] })
);

export const downloadDocuments = createAsyncAction(resolve => (documentId, documentName) =>
  resolve(async() => {
    const lang = localStorage.getItem("language");
    const response = await axios.get(`${getApiUrl()}/document/${documentId}`, { responseType: "blob", params: { lang } });

    return saveAs(response.data, documentName, response.data.type || "application/pdf");
  })
);

export const downloadDocument = async(url, documentName) => {
  const response = await axios.get(url, { responseType: "blob" });
  return saveAs(response.data, documentName, "application/pdf");
};



// WEBPACK FOOTER //
// ./src/actions/documentActions.js